import $ from 'jquery';
import 'jquery.mmenu/dist/jquery.mmenu';
import 'jquery.mmenu/dist/addons/autoheight/jquery.mmenu.autoheight';
import './mobile.scss';

$(function () {
    let menuElement = $('[id="menu"]');
    let clone = menuElement.clone();

    clone.attr('id', 'mmenu');
    clone.find('.submenu').removeClass('submenu');

    clone.find('> ul:first-child').append(
        clone.find('> ul:last-child').children()
    );

    clone.find('> ul:last-child').remove();
    clone.find('.hidden-md-up').remove();
    clone.find('.menu-logo').remove();

    clone.mmenu({
        extensions: [
            'popup',
            'pagedim-black',
        ],
        autoHeight: true,
    }, {
        //
    });

    const api = clone.data('mmenu');
    const hamburger = document.querySelector('.hamburger');

    api.bind('open:start', () => {
        setTimeout(() => {
            $(hamburger).addClass('is-active');
        }, 100);
    });

    api.bind('close:start', () => {
        setTimeout(() => {
            $(hamburger).removeClass('is-active');
        }, 100);
    });

    clone.on('click', 'a.mm-listitem__text', () => {
        api.close()
    })
});



// WEBPACK FOOTER //
// ./assets/app/js/menu/mobile.js